<template>
  <el-main :style="{height:height+'px'}" v-loading="loading">
    <div class="Scroll_content">
      <div>

        <div class="simkeropl">{{$t('addChildren.Edits')}}</div>
        <div style="display: flex;flex-wrap: wrap">
          <div style="margin-right: 24px" v-for="(item,index) in studentData" :key="index">
            <div class="grid-content bg-purple" @click="switch_id(item)" :style="{'border':last_student_sn==item.student_sn?'1px solid #FF6E17' : ''}">
              <img class="icon_dax" :src="item.avatar" alt="">
              <span class="tim_nam">{{$t('addChildren.Childs_Name')}}</span>
              <span class="mingziss">{{item.nickname}}</span>
              <span class="minzizi">{{$t('addChildren.Child_Birthday')}}</span>
              <span class="hanimsj">{{item.birth_date}}</span>

              <div class="xiugaim" @click="editChild(item,$event)">
                <img class="xg" src="../../assets/xiugai.png" alt="">
                {{$t('addChildren.Edit')}}
              </div>
                 <!-- 删除小孩按钮 -->
              <!-- <div class="xiugaimsx" @click="deleteStud(item,$event)">
                <img class="xg" src="../../assets/kl1.svg" alt="">
                {{$t('addChildren.Delete')}}
              </div> -->
            </div>
          </div>
          <el-col :span="8">
            <div class="grid-content bg-purple" @click="addChild">
              <div class="mltha">+ {{$t('addChildren.add')}}</div>
            </div>
          </el-col>
          <!-- <el-col :span="8"><div class="grid-content bg-purple"></div></el-col>
          <el-col :span="8"><div class="grid-content bg-purple"></div></el-col> -->
        </div>
        <div class="dian"></div>
      </div>
    </div>
                  <el-dialog class="dialog"
                  title=""
                  :visible.sync="dialogVisible"
                  width="40%"
                  :before-close="handleClose">
                    <span> {{$t('Childdialog.Parent')}} </span>
                     <span> {{$t('Childdialog.advisor')}}  </span>
                     <div>
                        <div class="sin_boimn">
                          <img class="immkkll" src="../../assets/Stroke1.svg" alt="">
                          <span style="color: #0B1D33;">{{user_info.mobile}}</span>
                        </div>
                        <div class="sin_boimn">
                          <img class="immkkll wx" src="../../assets/WeChat_lgo_icon1.svg" alt="">
                          <span> {{user_info.wechat}}</span>
                        </div>
                        <img class="ewm_img" :src="user_info.qr_code" alt="">
                     </div>
              </el-dialog>
  </el-main>
</template>
<script>
import { setStore, getStore, keys } from '@/store';
  // import IndexHeader from '../views/header'
  // import IndexFooter from '../views/footer'
  // import MyScheduled from '../views/scheduled'
  // import MyCourse from '../views/course'
  // import PastLesson from '../views/lesson'

  //引入header组件
  // import Header from '../header/header'

  export default {
    components: {
      // IndexHeader,
      // IndexFooter,
      // MyScheduled,
      // PastLesson,
      // MyCourse,
      // Header
    },
    data () {
      return {
        loading:false,
        height:100,
        studentData:[],
        last_student_sn:'',
        num:3,//非会员 最多能添加3个  会员根据套餐的孩子数量
        dialogVisible:false,
        user_info:[],
      }
    },
    created () {
      let height = document.body.offsetHeight-140;
      this.height = height
      if (getStore(keys.token)) {
        if (getStore(keys.userInfo).status == 0) {
          this.$router.push({
            path: '/sinadd'
          })
        }
      } else {
        this.$router.push({
          path: '/'
        })
        return false
      }
      this.num = getStore(keys.userProfile).member_status=='1'?getStore(keys.userProfile).member_kids:3
      this.get_children_all();
      this.getUser();
      this.Sales_information();
    },
    methods: {
      /**
       * 获取销售信息
       */
      Sales_information:function(){
        this.$http.get('/api/getUserInfo', {headers: {token:getStore(keys.token)}}).then((res) => {
          if (res.data.code == 200) {
            setStore(keys.user, res.data.data)
            this.user_info = res.data.data.salesperson_info
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },
      /**
       * 获取所有孩子信息
       */
      get_children_all:function(){
        this.$http.get('/api/students').then((res) => {
          if (res.data.code == 200) {
            console.log(res)
            this.studentData = res.data.data
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },
      /**
       * 跳转编辑小孩信息
       */
      editChild (item,e) {
        this.$router.push({ path: '/add?one=1&edit=' + encodeURIComponent(JSON.stringify(item)) });
        e.cancelBubble = true;
      },
      /**
       * 删除小孩方法
       */
      deleteStud (item,e) {
        let _this = this;
        this.$confirm(this.$t('errorprompt.del_1'), {
          confirmButtonText: this.$t('errorprompt.del_3'),
          cancelButtonText: this.$t('errorprompt.del_4'),
          type: 'warning'
        }).then(() => {
          this.$http.post('/api/students/studentid/delete', {
            student_sn: item.student_sn
          }).then((res) => {
            if (res.data.code == 200) {

              this.$message({
                type: 'sucess',
                message: this.$t('errorprompt.del_2')
              });
              _this.$root.$emit("addDpm");
              _this.get_children_all();
            } else {
              // this.$message({
              //   message: res.data.msg,
              //   type: 'warning'
              // })
              _this.$root.$emit("addDpm");
            }
          }).catch((error) => {
            console.log(error) // 请求失败返回的数据
          })
        }).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });

        //阻止事件冒泡发生
        e.cancelBubble = true;
      },
      /**
       * 添加小孩
       */
      addChild () {
        this.dialogVisible = true
        // if(this.studentData.length<this.num){
        //   this.$router.push({ path: '/add?add=0' })
        // }else{
        //   this.$root.$emit("addDpm");
        // }

      },
      switch_id(e){
        let _this = this;

        this.$http.post('/api/setLastStudent?',{
          last_student_sn:e.student_sn
        }).then((res) => {
          if (res.data.code == 200) {
            _this.getUser();
            this.$parent.getUser();

          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },
      //获取默认孩子信息
      getUser () {
        this.loading = true;
        this.$http.get('/api/user/profile').then((res) => {
          if (res.data.code == 200) {
            this.last_student_sn = res.data.data.last_student_sn
            this.loading = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },
    },
    mounted () {

    },
    watch: {

    },
  }
</script>
<style lang="less" scoped>
.simkeropl{
    margin-bottom:62px;
    // text-align: center;

    font-family: Roboto;
    font-size: 24px;
    font-weight: 500;
    line-height: 32px;
    letter-spacing: 0px;

    font-feature-settings: "kern" on;
    color: #000000;

}
.grid-content{
  // border:1px solid red;
  border-radius: 12px;
  background: #FFFFFF;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  overflow: hidden;
  margin-bottom:20px;
  cursor: pointer;
  width: 500px;
  height: 300px;
  .icon_dax{
    width:60px;
    height:60px;
    margin-top:25px;
    margin-left:25px;
    margin-bottom:24px;
  }
  .tim_nam{
    font-family: Sofia Pro;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 16px;
    /* identical to box height */
    color: #6B6B6B;
    display: block;
    text-indent: 30px;
  }
  .mingziss{
    font-family: Sofia Pro;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 18px;
    /* identical to box height */
    color: #000000;
    display: block;
    text-indent: 30px;
    margin-top:18px;
  }
  .minzizi{
    font-family: Sofia Pro;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 16px;
    /* identical to box height */
    color: #6B6B6B;
    display: block;
    text-indent: 30px;
    margin-top:32px;
  }
  .hanimsj{
    font-family: Sofia Pro;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 18px;
    /* identical to box height */
    color: #000000;
    display: block;
    text-indent: 30px;
    margin-top:18px;
  }
  .xiugaim{
    width: 122px;
    height: 36px;
    left: 195px;
    top: 270px;
    //background: #4B69FE;
    border-radius: 5px;
    font-family: Roboto;
    font-style: normal;
    //font-weight: bold;
    font-size: 16px;
    line-height: 18px;
    /* identical to box height */
    display: flex;
    align-items: center;
    text-align: center;
    color: #FF6E17;
    margin-top:3px;
    margin-bottom:16px;
    margin-right:20px;
    float: right;
    cursor: pointer;
    .xg{
      margin-left:18px;
      margin-right:18px;
      width: 16px;
    }
  }

}
.mltha{
  font-family: Sofia Pro;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  // line-height: 100%;
  /* identical to box height, or 18px */
  height: 331px;
  text-align: center;
  text-transform: capitalize;
  line-height: 331px;
  color: #FF6E17;
  cursor: pointer;
}

  .xiugaimsx{
    width: 122px;
    height: 36px;
    left: 141px;
    top: -50px;
    background: #FF0000;
    border-radius: 5px;
    font-family: Sofia Pro;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 18px;
    /* identical to box height */
    display: flex;
    align-items: center;
    text-align: center;
    color: #FFFFFF;
    margin-top:3px;
    margin-bottom:16px;
    margin-right:20px;
    float: right;
    cursor: pointer;
    position: relative;
    .xg{
      margin-left:18px;
      margin-right:18px;
    }
  }
  .dialog{
    span{
      display: block;
      text-align: center;
      font-weight: 700;
      font-size: 18px;
      line-height: 150%;
      color: #000000;
      width: 380px;
      word-break: break-word;
      margin: 10px auto;
    }
    .sin_boimn{
      width: 60%;
      margin: 20px auto;
      display: flex;
      span{
        margin-left: 20px;
        text-align: left;

      }
    }
  }
  .ewm_img{
    width: 106px;
    height: 106px;
    margin: 40px auto 20px auto;
    display: block;
    border:5px solid #FF6E17;
    border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/children/addChildren.vue